import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';

export default function Login() {
  const [form, setForm] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.username || !form.password) return toast.error('Please fill all fields');
    setLoading(true);
    try {
      const res = await api.post('/api/auth/login', form);
      login(res.data);
      toast.success('Welcome back!');
      navigate(res.data.role === 'superadmin' ? '/superadmin' : '/owner');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card} className="fade-in">
        <div style={styles.logo}>
          <div style={styles.logoIcon}>🍽️</div>
          <h1 style={styles.appName}>QR Menu</h1>
          <p style={styles.tagline}>Smart ordering for smart restaurants</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="label">Username</label>
            <input
              className="input"
              placeholder="Enter your username"
              value={form.username}
              onChange={e => setForm({ ...form, username: e.target.value })}
            />
          </div>
          <div className="form-group">
            <label className="label">Password</label>
            <input
              className="input"
              type="password"
              placeholder="Enter your password"
              value={form.password}
              onChange={e => setForm({ ...form, password: e.target.value })}
            />
          </div>
          <button className="btn btn-primary btn-full" type="submit" disabled={loading}>
            {loading ? <span className="spinner" style={{ width: 20, height: 20 }} /> : 'Login'}
          </button>
        </form>
        <p style={styles.footer}>Powered by QR Menu Platform</p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #fff0eb 0%, #fafafa 50%, #fff0eb 100%)',
    padding: '24px',
  },
  card: {
    background: 'white',
    borderRadius: '20px',
    padding: '40px 32px',
    width: '100%',
    maxWidth: '400px',
    boxShadow: '0 20px 60px rgba(255,107,53,0.15)',
  },
  logo: { textAlign: 'center', marginBottom: '32px' },
  logoIcon: { fontSize: '48px', marginBottom: '8px' },
  appName: { fontSize: '28px', fontWeight: '700', color: '#2C3E50', marginBottom: '4px' },
  tagline: { fontSize: '13px', color: '#7F8C8D' },
  footer: { textAlign: 'center', fontSize: '12px', color: '#7F8C8D', marginTop: '24px' },
};
